export const FAKE_LOCAL_BMS_LICENSE_ACCESS = (orgId: string, hubCode: string) => ({
    auth_details: {
        client_id: 'blockmodel-development',
        exp: Date.now() + 24 * 60 * 60 * 1000,
        iat: Date.now() - 24 * 60 * 60 * 1000,
        sid: '???',
        ver: 'v0',
        type: 'BentleyJWTAccessToken',
        scope: [
            'openid',
            'profile',
            'email',
            'evo.discovery',
            'evo.workspace',
            'evo.blocksync',
            'evo.users:read',
        ],
    },
    user: {
        org_id: orgId,
        org_name: '???',
        sub: '???',
    },
    entitlements: {
        org_id: orgId,
        org_name: '???',
        hub_code: hubCode,
        services: ['blockmodel'],
        roles: [],
    },
});
